import { createBrowserHistory } from 'history';

const historyConfig = {
    basename: 'sct2'
};

//export default createBrowserHistory(historyConfig);
export default createBrowserHistory();
